<template>
  <div class="tapeoutalert-wrap">
    <div class="tapeoutalert">
      <img class="close" @click="$root.showTapeOutAlert=false" src="../../../images/closeTapeoutAlert.png" alt />
      <div class="title">
        <img src="../../../images/tapeoutalerttip.png" alt />
        <span>温馨提示</span>
      </div>
      <div class="text">
        因运营商系统调整，辽宁联通和天津联通的提速功能
        <br />暂时下线，预计
        <span>9月1日</span>恢复。
        <br />对于受影响的已提速用户，我们会给予双倍延时补偿。
      </div>
      <div class="text">
        例如：
        <br />如受影响时间为
        <span>10天</span>，待提速服务恢复后，给予
        <span>20天</span>
        <br />补偿。
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.tapeoutalert-wrap {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.tapeoutalert {
  width: 463px;
  height: 331px;
  background: rgba(43, 44, 68, 1);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .close {
    width: 18px;
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
  }
  .title {
    margin: 40px auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(230, 230, 231, 1);
    font-size: 24px;
    img {
      margin-right: 9px;
      width: 29px;
    }
  }
  .text{
      margin: 0 33px 20px;
      color:rgba(142,165,191,1);
      font-size: 16px;
      line-height:28px;
      span{
          color: #06C6F1;
      }
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/tips/tapeOutAlert.vue